import axiosInstance from "../../utils/Api";

export const SubjectListApi = async () =>
  await axiosInstance
    .get("subject/list")
    .then((data) => {
      return data.data;
    })
    .catch((error) => {});
